export const SUB_ORG_BILLING_INFO_LOAD = 'SUB_ORG_BILLING_INFO_LOAD'
export const SUB_ORG_BILLING_INFO_LOAD_PENDING = 'SUB_ORG_BILLING_INFO_LOAD_PENDING'
export const SUB_ORG_BILLING_INFO_LOAD_FULFILLED = 'SUB_ORG_BILLING_INFO_LOAD_FULFILLED'
export const SUB_ORG_BILLING_INFO_LOAD_REJECTED = 'SUB_ORG_BILLING_INFO_LOAD_REJECTED'
